/**
 * @description apiからデータ配列を返す
 */

const axios = require('axios');

export const getData = (url: string) => {
  return axios.get(url);
};
